import React from 'react';
import { ContentCard, FilterSetController, Filter } from '@weezevent/nacre';
import Style from './widgetRow.module.css';
import Event from '../../models/eventModel';
import { useTranslation } from 'react-i18next';

const SearchModule = ({ organizationId, sortedWidget, filters, setFilters, loadingWidgets, context }) => {
    const { t } = useTranslation();

    const moduleType = [
        { key: 'filtered', name: 'filtered', text: t('ticket.widgets.filters.module_type') },
        { key: 'multi-event', name: 'multi-event', text: t('ticket.widgets.filters.multi_events') }
    ];

    const [eventModels] = Event.useApiModel(
        {
            organizationId
        },
        [organizationId]
    );

    const [, setAllSelected] = React.useState(false);

    const onChangeSearch = React.useCallback(
        value => {
            let tmpFilters = { ...filters };
            if (value !== '' && value !== null) {
                tmpFilters = { ...tmpFilters, search: value };
            } else {
                delete tmpFilters.search;
            }
            setFilters(tmpFilters);
        },
        [filters]
    );

    const resetSelected = React.useCallback(() => {
        setAllSelected(false);
    }, []);

    const changeSearch = React.useCallback(
        values => {
            if (filters.search !== undefined && filters.search.length > 0) {
                values.search = filters.search;
            }
            setFilters(values);
            resetSelected();
        },
        [filters]
    );

    const listEvents = React.useMemo(() => {
        return eventModels
            ? eventModels.map(event => {
                  return { key: `${event.id}`, name: `${event.id}`, text: `${event.name}` };
              })
            : [];
    }, [eventModels]);

    return (
        <ContentCard>
            <FilterSetController
                className={Style['filter_card_widget']}
                total={sortedWidget?.length}
                isLoadingTotal={loadingWidgets}
                labelTotal={t('ticket.widgets.modules')}
                labelReset={t('ticket.common.action.reset')}
                labelFilters={t('ticket.widgets.filters_name')}
                initialValues={filters}
                onReset={() => {}}
                search={{
                    onChange: (synth, value) => {
                        onChangeSearch(value);
                        resetSelected();
                    },
                    handleReset: (synth, value) => {
                        onChangeSearch(null);
                    },
                    value: filters?.search || '',
                    placeholder: t('ticket.widgets.search_bar_placeholder')
                }}
                onChange={changeSearch}
            >
                {context === 'default' && (
                    <Filter
                        name="module_type"
                        labelName={t('ticket.widgets.category_filters.module_type')}
                        multiple
                        options={moduleType}
                        index="0"
                        labelCTA={t('ticket.common.action.search')}
                    />
                )}
                <Filter name="event__in" labelName={t('ticket.widgets.category_filters.events')} options={listEvents} index="1" />
            </FilterSetController>
        </ContentCard>
    );
};

export default SearchModule;
